<template>
<div class="chapter">
<div class="inner_page">
<div id="d2-d5f88a5f148ed-d1e247"><span id="pageiii">
<h1 class="book-title ">THE APOLLO DECEPTION</h1>
<h2 class="book-author ">Mitch Silver</h2>
<p class="publisher-logo "><span class="image-centered" id="imgd1e1108"><img alt="" src="OEBPS/images/9781448303595_epub_002.jpg"/></span></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781448303595_epub_tp.vue?4fe79a19